import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { Account } from '../types/account';

type AccountsResponse = {
    accounts: Account[];
};

async function getAccounts(workpaperId: string, hasEntityAccount?: boolean): Promise<AccountsResponse> {
    const { data } = await api.get(`/workpapers/${workpaperId}/accounts`, {
        params: {
            hasEntityAccount,
        },
    });
    return data;
}

export function useWorkpaperAccounts(workpaperId: string, hasEntityAccount?: boolean): UseQueryResult<AccountsResponse, unknown> {
    return useQuery(['workpapers', workpaperId, 'accounts', hasEntityAccount], () => getAccounts(workpaperId, hasEntityAccount), {
        enabled: Boolean(workpaperId),
    });
}
